import { render, staticRenderFns } from "./Bildung.vue?vue&type=template&id=d7c2b5c6&scoped=true&"
import script from "./Bildung.vue?vue&type=script&lang=js&"
export * from "./Bildung.vue?vue&type=script&lang=js&"
import style0 from "./Bildung.vue?vue&type=style&index=0&id=d7c2b5c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c2b5c6",
  null
  
)

export default component.exports